var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatelliteAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "satellite_alt",
    clipPath: "url(#clip0_13544_44940)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "satellite_alt_2",
    d: "M20.9991 13.9996H22.9991C22.9991 18.9696 18.9691 22.9996 13.9991 22.9996V20.9996C17.8691 20.9996 20.9991 17.8696 20.9991 13.9996ZM13.9991 16.9996V18.9996C16.7591 18.9996 18.9991 16.7596 18.9991 13.9996H16.9991C16.9991 15.6596 15.6591 16.9996 13.9991 16.9996ZM18.2591 0.58957L21.7991 4.12957C22.5791 4.90957 22.5791 6.17957 21.7991 6.95957L18.6191 10.1396C17.8391 10.9196 16.5691 10.9196 15.7891 10.1396L14.5491 8.89957L13.8391 9.59957L15.0791 10.8396C15.8591 11.6196 15.8591 12.8896 15.0791 13.6696L13.6691 15.0796C12.8891 15.8596 11.6191 15.8596 10.8391 15.0796L9.59914 13.8396L8.88914 14.5496L10.1291 15.7896C10.9091 16.5696 10.9091 17.8396 10.1291 18.6196L6.94914 21.7996C6.16914 22.5796 4.89914 22.5796 4.11914 21.7996L0.579141 18.2596C-0.200859 17.4796 -0.200859 16.2096 0.579141 15.4296L3.75914 12.2496C4.53914 11.4696 5.80914 11.4696 6.58914 12.2496L7.82914 13.4896L8.53914 12.7796L7.29914 11.5496C6.51914 10.7696 6.51914 9.49957 7.29914 8.71957L8.71914 7.29957C9.49914 6.51957 10.7691 6.51957 11.5491 7.29957L12.7891 8.53957L13.4991 7.82957L12.2491 6.59957C11.4691 5.81957 11.4691 4.54957 12.2491 3.76957L15.4291 0.58957C16.2191 -0.20043 17.4791 -0.20043 18.2591 0.58957ZM3.05914 15.7896L1.99914 16.8496L5.53914 20.3896L6.59914 19.3296L3.05914 15.7896ZM5.17914 13.6696L4.11914 14.7296L7.65914 18.2696L8.71914 17.2096L5.17914 13.6696ZM10.1291 8.71957L8.71914 10.1296L12.2591 13.6696L13.6691 12.2596L10.1291 8.71957ZM14.7291 4.11957L13.6691 5.17957L17.2091 8.71957L18.2691 7.65957L14.7291 4.11957ZM16.8491 1.99957L15.7891 3.05957L19.3291 6.59957L20.3891 5.53957L16.8491 1.99957Z",
    fill: "#868CA2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13544_44940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatelliteAlt);
export default __webpack_public_path__ + "static/media/satellite_alt.bfdfba278b160c3156a33c9d45cca185.svg";
export { ForwardRef as ReactComponent };